import { useAuth } from "@/auth";
import { isAuthenticated } from "@/auth/utils";
import { apiThreadPool } from "@/cache/SpatioTemporalTileCache/ApiQueryThreadPool";
import { useAppDispatch } from "@/reducer";
import { setUserStats } from "@/reducer/UserStatsState";
import type { UserStatsResponse } from "@mm/api.meteomatics.com";
import { useEffect } from "react";

export function useMeteomaticsApi() {
  const session = useAuth().session;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isAuthenticated(session) || session?.token === undefined) {
      apiThreadPool.updateAuthentication(null);
      return;
    }

    apiThreadPool
      .updateAuthentication(session.token.access_token)
      .then(() => apiThreadPool.getUserStats())
      .then((userStats: UserStatsResponse) => {
        apiThreadPool.updateHardParallelLimit(userStats["user statistics"]["requests in parallel"]["hard limit"]);
        dispatch(
          setUserStats({
            username: userStats["user statistics"]?.username,
            mixType: userStats["user statistics"]?.["mix type"],
          }),
        );
      });
  }, [session]);

  return apiThreadPool;
}
